import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import d1 from "../../Assets/images/d1.png";

const ImagePreview = ({ showModal, selectedImage, onClose, title }) => {
  const [image, setImage] = useState(null);

  useEffect(() => {
    setImage(selectedImage);
  }, [selectedImage]);

  return (
    <>
      <Modal show={showModal} onHide={onClose} centered>
        <Modal.Header closeButton>
          {/* <Modal.Title>{title || "Image Preview"}</Modal.Title> */}
        </Modal.Header>
        <Modal.Body className="text-center">
          {image ? (
            <img
              src={image}
              // alt="Image Preview"
              className="img-fluid"
              style={{ maxHeight: "500px" }}
            />
          ) : (
            <p>
              <img
                src={d1}
                // alt="Image Preview"
                className="img-fluid"
                style={{ maxHeight: "500px" }}
              />
            </p>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ImagePreview;
